import Cookies from "js-cookie";
import createRestrictedKey from "storefront/GrailedAPI/v1/Users/Algolia/createRestrictedKey";
import { UserSelf } from "storefront/User";
import { isUnexpiredSearchKey } from "./isUnexpiredSearchKey";
import { SearchKey } from "./SearchKey";

const COOKIE_NAME = "algolia_user_restricted_search_key";

/**
 * @name Algolia.fetchUserRestrictedSearchKey
 * @description Fetches a user-restricted search key from the Grailed API. We assume the key is cached by the API
 * in a cookie. We check the cookie first so that we don't overload the Grailed API endpoint with
 * requests for search keys.
 */
const fetchUserRestrictedSearchKey = (
  currentUser: UserSelf,
): Promise<SearchKey> => {
  const value = Cookies.get(COOKIE_NAME);

  return value && isUnexpiredSearchKey(value)
    ? Promise.resolve({
        value,
      })
    : createRestrictedKey(currentUser.id);
};

export default fetchUserRestrictedSearchKey;
